module.exports = __webpack_public_path__ + "img/pure_oak_904m_list.273ab0bf.jpg";